import Vue from 'vue';
import Vuex from 'vuex';
//import Axios from "axios";
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex);

export const store = new Vuex.Store({
    plugins: [createPersistedState()],
    state: {
        token: '',
        user_id: '',
        group_id: '',
        confirmMessage: {
            show: false
        },
        notifyMessage: {
            show: false
        },
        login: false,
        refresh: {},
        realtimeConnect: false,
        newData: null,
        playNotification: false,
        playDisconnected: false,
        playOpened: false,
        playSuspend: false,
        playNew: false,
        copy: {}

    },
    mutations: {
        setToken(state, data){
            state.token = data
        },
        setUserId(state, data){
            state.user_id = data
        },
        setConfirmMessage(state, data){
            state.confirmMessage = data
        },
        setNotifyMessage(state, data){
            state.notifyMessage = data
        },
        setLogin(state, data){
            state.login = data
        },
        setRefresh(state, payLoad){
            state.refresh = payLoad
        },
        setRealtimeConnect(state, payLoad){
            state.realtimeConnect = payLoad
        },
        setNewData(state, payLoad){
            state.newData = payLoad
        },
        setPlayNotification(state, payLoad){
            state.playNotification = payLoad
        },
        setPlayDisconnected(state, payLoad){
            state.playDisconnected = payLoad
        },
        setPlayOpened(state, payLoad){
            state.playOpened = payLoad
        },
        setPlayNew(state, payLoad){
            state.playNew = payLoad
        },
        setPlaySuspend(state, payLoad){
            state.playSuspend = payLoad
        },
        setCopy(state, payLoad){
            state.copy = payLoad
        },
        setGroupId(state, payLoad){
            state.group_id = payLoad
        },

    },
    actions: {
        token(context, payLoad) {
            context.commit('setToken', payLoad)
        },
        user_id(context, payLoad) {
            context.commit('setUserId', payLoad)
        },
        group_id(context, payLoad) {
            context.commit('setGroupId', payLoad)
        },
        getConfirmMessage(context, payLoad) {
            context.commit('setConfirmMessage', payLoad)
        },
        getNotifyMessage(context, payLoad) {
            context.commit('setNotifyMessage', payLoad)
        },
        loginIt(context, payLoad){
            context.commit('setLogin', payLoad)
        },
        getRefresh(context, payLoad) {
            context.commit('setRefresh', payLoad)
        },
        getRealtimeConnect(context, payLoad) {
            context.commit('setRealtimeConnect', payLoad)
        },
        getNewData(context, payLoad) {
            context.commit('setNewData', payLoad)
        },
        getPlayNotification(context, payLoad) {
            context.commit('setPlayNotification', payLoad)
        },
        getPlayOpened(context, payLoad) {
            context.commit('setPlayOpened', payLoad)
        },
        getPlayDisconnected(context, payLoad) {
            context.commit('setPlayDisconnected', payLoad)
        },
        getPlaySuspend(context, payLoad) {
            context.commit('setPlaySuspend', payLoad)
        },
        getPlayNew(context, payLoad) {
            context.commit('setPlayNew', payLoad)
        },
        getCopy(context, payLoad) {
            context.commit('setCopy', payLoad)
        },

    },
    getters: {
        token: state => state.token,
        group_id: state => state.group_id,
        user_id: state => state.user_id,
        confirmMessage: state => state.confirmMessage,
        notifyMessage: state => state.notifyMessage,
        login: state => state.login,
        getRefresh: state => state.refresh,
        connected : state => state.realtimeConnect,
        newData : state => state.newData,
        playNotification : state => state.playNotification,
        playDisconnected : state => state.playDisconnected,
        playOpened : state => state.playOpened,
        playSuspend : state => state.playSuspend,
        playNew : state => state.playNew,
        copy: state => state.copy

    },
});